import { render, staticRenderFns } from "./QuestionInputArea.vue?vue&type=template&id=62ec8ce2&scoped=true&lang=pug&"
import script from "./QuestionInputArea.vue?vue&type=script&lang=ts&"
export * from "./QuestionInputArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ec8ce2",
  null
  
)

export default component.exports